import { createSlice } from "@reduxjs/toolkit";
import {
    getUserListBySearchQuery,
} from "api/users";

const initialState = {
    loading: false,
    error: null,
    usersSuggestionList: [],
    allUsers: [],
    isClicked: false,
    userLink: {},
    isInternal: false
};

export const usersReducer = createSlice({
    name: "usersReducer",
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setUsersSuggestionsList: (state, action) => {
            state.usersSuggestionList = action.payload;
        },
        setRMInitiated: (state, action) => {
            state.rmInitiated = action.payload
        },
        setRmLink: (state, action) => {
            state.userLink = action.payload
        },
        setIsUserClicked: (state, action) => {
            state.isClicked = action.payload
        },
        setIsInternal: (state, action) => {
            state.isInternal = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserListBySearchQuery.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getUserListBySearchQuery.fulfilled, (state, action) => {
                state.loading = false;
                state.usersSuggestionList = action.payload.data;
                state.error = null;
            })
            .addCase(getUserListBySearchQuery.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        
    }
});

export const {
    setLoading,
    setError,
    setUsersSuggestionsList,
    setRMInitiated,
    setIsUserClicked,
    setIsInternal
} = usersReducer.actions;

export default usersReducer.reducer;